import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.staff_id,
      name: this.props.staff_data.name,
      email: this.props.staff_data.email,
      civil_state: this.props.staff_data.civil_state,
      phone: this.props.staff_data.phone,
      blood_type: this.props.staff_data.blood_type,
      dados_bancarios: this.props.staff_data.dados_bancarios,
      date_of_birth: this.props.staff_data.date_of_birth_str,
      country_birth: this.props.staff_data.country_birth,
      uf_birth: this.props.staff_data.uf_birth,
      city_birth: this.props.staff_data.city_birth,
      address: this.props.staff_data.address,
      number: this.props.staff_data.number,
      complement: this.props.staff_data.complement,
      neighborhood: this.props.staff_data.neighborhood,
      city: this.props.staff_data.city,
      uf: this.props.staff_data.uf,
      country: this.props.staff_data.country,
      pis: this.props.staff_data.pis,
      cep: this.props.staff_data.cep,
      photo: "",
      cpf: this.props.staff_data.cpf_str,
      identity: this.props.staff_data.identity,
      id_uf: this.props.staff_data.id_uf,
      id_exp: this.props.staff_data.id_exp,
      id_date: this.props.staff_data.id_date,
      ctps_uf: this.props.staff_data.ctps_uf,
      ctps: this.props.staff_data.ctps,
      ctps_expedition: this.props.staff_data.ctps_expedition,
      escola_formacao: this.props.staff_data.escola_formacao,
      scholarly: this.props.staff_data.scholarly,
      confidence_us: this.props.staff_data.confidence_us,
      expire_us: this.props.staff_data.expire_us,
      confidence_eu: this.props.staff_data.confidence_eu,
      expire_eu: this.props.staff_data.expire_eu,
      passport: this.props.staff_data.passport,
      passport_expiration: this.props.staff_data.passport_expiration,
      voting_title: this.props.staff_data.voting_title,
      voting_title_zone: this.props.staff_data.voting_title_zone,
      voting_title_session: this.props.staff_data.voting_title_session,
      cnh: this.props.staff_data.cnh,
      cnh_expiration: this.props.staff_data.cnh_expiration,
      reservista: this.props.staff_data.reservista,
      reservista_cat: this.props.staff_data.reservista_cat,
      certificado_militar: this.props.staff_data.certificado_militar,
      certificado_militar_ministerio: this.props.staff_data.certificado_militar_ministerio,
      certificado_militar_obs: this.props.staff_data.certificado_militar_obs,
      visto_usa: this.props.staff_data.visto_usa,
      crea: this.props.staff_data.crea,
      crea_titulo: this.props.staff_data.crea_titulo,
      crea_expedicao: this.props.staff_data.crea_expedicao,
      crea_validade: this.props.staff_data.crea_validade,
      aso: this.props.staff_data.aso,
      hired: this.props.staff_data.hired,
      fired: this.props.staff_data.fired,
      mom: this.props.staff_data.mom,
      dad: this.props.staff_data.dad,
      license: this.props.staff_data.license,
      canac: this.props.staff_data.canac,
      inscription: this.props.staff_data.inscription,
      hour_value: this.props.staff_data.hour_value,
      sispat: this.props.staff_data.sispat,
      uf_list: this.props.uf_list,
      sapiens_code: this.props.sapiens_code,
    };

    //bind específico
    // this.edit = this.edit.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.staff_data.name !== 'undefined' && Array.isArray(newProps.uf_list)) {
      this.setState({
        id: newProps.staff_id,
        name: newProps.staff_data.name,
        email: newProps.staff_data.email,
        civil_state: newProps.staff_data.civil_state,
        phone1: newProps.staff_data.phone1,
        phone2: newProps.staff_data.phone2,
        blood_type: newProps.staff_data.blood_type,
        dados_bancarios: newProps.staff_data.dados_bancarios,
        date_of_birth: newProps.staff_data.date_of_birth_str,
        country_birth: newProps.staff_data.country_birth,
        uf_birth: newProps.staff_data.uf_birth,
        city_birth: newProps.staff_data.city_birth,
        address: newProps.staff_data.address,
        number: newProps.staff_data.number,
        complement: newProps.staff_data.complement,
        neighborhood: newProps.staff_data.neighborhood,
        city: newProps.staff_data.city,
        uf: newProps.staff_data.uf,
        country: newProps.staff_data.country,
        pis: newProps.staff_data.pis,
        cep: newProps.staff_data.cep,
        cpf: newProps.staff_data.cpf_str,
        identity: newProps.staff_data.identity,
        id_uf: newProps.staff_data.id_uf,
        id_exp: newProps.staff_data.id_exp,
        id_date: newProps.staff_data.id_date,
        ctps_uf: newProps.staff_data.ctps_uf,
        ctps: newProps.staff_data.ctps,
        ctps_expedition: newProps.staff_data.ctps_expedition,
        escola_formacao: newProps.staff_data.escola_formacao,
        scholarly: newProps.staff_data.scholarly,
        confidence_us: newProps.staff_data.confidence_us,
        expire_us: newProps.staff_data.expire_us,
        confidence_eu: newProps.staff_data.confidence_eu,
        expire_eu: newProps.staff_data.expire_eu,
        passport: newProps.staff_data.passport,
        passport_expiration: newProps.staff_data.passport_expiration,
        voting_title: newProps.staff_data.voting_title,
        voting_title_zone: newProps.staff_data.voting_title_zone,
        voting_title_session: newProps.staff_data.voting_title_session,
        cnh: newProps.staff_data.cnh,
        cnh_expiration: newProps.staff_data.cnh_expiration,
        reservista: newProps.staff_data.reservista,
        reservista_cat: newProps.staff_data.reservista_cat,
        certificado_militar: newProps.staff_data.certificado_militar,
        certificado_militar_ministerio: newProps.staff_data.certificado_militar_ministerio,
        certificado_militar_obs: newProps.staff_data.certificado_militar_obs,
        visto_usa: newProps.staff_data.visto_usa,
        crea: newProps.staff_data.crea,
        crea_titulo: newProps.staff_data.crea_titulo,
        crea_expedicao: newProps.staff_data.crea_expedicao,
        crea_validade: newProps.staff_data.crea_validade,
        aso: newProps.staff_data.aso,
        hired: newProps.staff_data.hired,
        fired: newProps.staff_data.fired,
        mom: newProps.staff_data.mom,
        dad: newProps.staff_data.dad,
        license: newProps.staff_data.license,
        canac: newProps.staff_data.canac,
        inscription: newProps.staff_data.inscription,
        hour_value: newProps.staff_data.hour_value,
        sispat: newProps.staff_data.sispat,
        sapiens_code: newProps.staff_data.sapiens_code,
        uf_list: newProps.uf_list,
        loaded: 1,
      });
    }
  }


  // // Fetch salvando a edição
  // edit(event) {
  //   event.preventDefault();
  //   var data = new FormData();
  //   var imagedata = document.querySelector(".input-photo").files[0];
  //   data.append("name", this.state.name);
  //   data.append("email", this.state.email);
  //   data.append("civil_state", this.state.civil_state);
  //   data.append("phone1", this.state.phone1);
  //   data.append("phone2", this.state.phone2);
  //   data.append("blood_type", this.state.blood_type);
  //   data.append("dados_bancarios", this.state.dados_bancarios);
  //   data.append("date_of_birth", this.state.date_of_birth);
  //   data.append("country_birth", this.state.country_birth);
  //   data.append("uf_birth", this.state.uf_birth);
  //   data.append("city_birth", this.state.city_birth);
  //   data.append("address", this.state.address);
  //   data.append("number", this.state.number);
  //   data.append("complement", this.state.complement);
  //   data.append("neighborhood", this.state.neighborhood);
  //   data.append("city", this.state.city);
  //   data.append("uf", this.state.uf);
  //   data.append("country", this.state.country);
  //   data.append("pis", this.state.pis);
  //   data.append("cep", this.state.cep);
  //   data.append("cpf", this.state.cpf);
  //   data.append("identity", this.state.identity);
  //   data.append("id_uf", this.state.id_uf);
  //   data.append("id_exp", this.state.id_exp);
  //   data.append("id_date", this.state.id_date);
  //   data.append("ctps_uf", this.state.ctps_uf);
  //   data.append("ctps", this.state.ctps);
  //   data.append("ctps_expedition", this.state.ctps_expedition);
  //   data.append("escola_formacao", this.state.escola_formacao);
  //   data.append("scholarly", this.state.scholarly);
  //   data.append("confidence_us", this.state.confidence_us);
  //   data.append("expire_us", this.state.expire_us);
  //   data.append("confidence_eu", this.state.confidence_eu);
  //   data.append("expire_eu", this.state.expire_eu);
  //   data.append("passport", this.state.passport);
  //   data.append("passport_expiration", this.state.passport_expiration);
  //   data.append("voting_title", this.state.voting_title);
  //   data.append("voting_title_zone", this.state.voting_title_zone);
  //   data.append("voting_title_session", this.state.voting_title_session);
  //   data.append("cnh", this.state.cnh);
  //   data.append("cnh_expiration", this.state.cnh_expiration);
  //   data.append("reservista", this.state.reservista);
  //   data.append("reservista_cat", this.state.reservista_cat);
  //   data.append("certificado_militar", this.state.certificado_militar);
  //   data.append("certificado_militar_ministerio", this.state.certificado_militar_ministerio);
  //   data.append("certificado_militar_obs", this.state.certificado_militar_obs);
  //   data.append("visto_usa", this.state.visto_usa);
  //   data.append("crea", this.state.crea);
  //   data.append("crea_titulo", this.state.crea_titulo);
  //   data.append("crea_expedicao", this.state.crea_expedicao);
  //   data.append("crea_validade", this.state.crea_validade);
  //   data.append("aso", this.state.aso);
  //   data.append("hired", this.state.hired);
  //   data.append("fired", this.state.fired);
  //   data.append("mom", this.state.mom);
  //   data.append("dad", this.state.dad);
  //   data.append("license", this.state.license);
  //   data.append("canac", this.state.canac);
  //   data.append("inscription", this.state.inscription);
  //   data.append("hour_value", this.state.hour_value);
  //   data.append("sispat", this.state.sispat);
  //   data.append("sapiens_code", this.state.sapiens_code);
  //   data.append("id", this.state.id);
  //   data.append("imagem", imagedata);
  //   var header = this.refs.request_api.header();
  //   var self = this;
  //   this.props.handleAlert('', '', 'open');
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/edicao', {
  //       method: 'POST',
  //       mode: 'cors',
  //       headers: value,
  //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <form onSubmit={this.edit}>
      <h4>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.tituloInformacoesPessoais}</h4>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Nome}:</label>
          <input type="text" className="form-control" disabled name="name" value={this.state.name} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDoColaborador} onChange={this.handleChange.bind(this, 'name')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Email}:</label>
          <input type="text" className="form-control" disabled name="email" value={this.state.email} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EmailDoColaborador} onChange={this.handleChange.bind(this, 'email')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.EstadoCivil}:</label>
          <input type="text" className="form-control" disabled name="civil_state" value={this.state.civil_state} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EstadoCivil} onChange={this.handleChange.bind(this, 'civil_state')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.TipoSanguineo}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TipoSanguineo} className="form-control" disabled name="blood_type" value={this.state.blood_type} onChange={this.handleChange.bind(this, 'blood_type')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Telefone1}:</label>
          <input type="text" className="form-control" disabled name="phone1" value={this.state.phone1} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TelefoneDoColaborador} onChange={this.handleChange.bind(this, 'phone1')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Telefone2}:</label>
          <input type="text" className="form-control" disabled name="phone2" value={this.state.phone2} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TelefoneDoColaborador} onChange={this.handleChange.bind(this, 'phone2')} />
        </div>
      </div>
      <div className="form-group">
        <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.DadosBancarios}:</label>
        <textarea style={{ height: 130 }} type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.DadosBancarios} className="form-control" disabled name="dados_bancarios" value={this.state.dados_bancarios} onChange={this.handleChange.bind(this, 'dados_bancarios')} />
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Nascimento}:</label>
          <InputMask value={this.state.date_of_birth} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NascimentoDoColaborador} maskChar={null} name="date_of_birth" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'date_of_birth')}/>
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PaisNascimento}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.PaisNascimento} className="form-control" disabled name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.UFNascimento}:</label>
          <Select
            className=""
            name="uf_birth"
            value={this.state.uf_birth}
            searchable={true}
            placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SelecioneOUF}
            onChange={this.handleSelectChange.bind(this, 'uf_birth')}
            options={this.state.uf_list}
            disabled
          />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CidadeNascimento}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CidadeNascimento} className="form-control" disabled name="city_birth" value={this.state.city_birth} onChange={this.handleChange.bind(this, 'city_birth')} />
        </div>
      </div>
      <hr/>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Endereco}:</label>
          <input type="text" className="form-control" disabled placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EnderecoDoColaborador} name="address" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Numero}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Numero} className="form-control" disabled name="number" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Complemento}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Complemento} className="form-control" disabled name="complement" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Bairro}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.BairroDoColaborador} className="form-control" disabled name="neighborhood" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Cidade}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CidadeDoColaborador} className="form-control" disabled name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.UF}:</label>
          <Select
            className=""
            name="uf"
            value={this.state.uf}
            searchable={true}
            placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SelecioneOUF}
            onChange={this.handleSelectChange.bind(this, 'uf')}
            options={this.state.uf_list}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Pais}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Pais} className="form-control" disabled name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PIS}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.PIS} className="form-control" disabled name="pis" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CEP}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CEPDoColaborador} className="form-control" disabled name="cep" value={this.state.cep} onChange={this.handleChange.bind(this, 'cep')} />
        </div>
        {/* <div className="col-md-6 form-group">
          <label>Foto:</label>
          <input type="text" type="file" name="photo" className="form-control input-photo" placeholder="Arquivo" value={this.state.photo} onChange={this.handleChange.bind(this, 'photo')} />
        </div> */}
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CPF}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CPFDoColaborador} className="form-control" disabled name="cpf" value={this.state.cpf} onChange={this.handleChange.bind(this, 'cpf')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Identidade}:</label>
          <input type="text" className="form-control" disabled name="identity" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.IDUF}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EstadoDeEmissaoDaID} className="form-control" disabled name="id_uf" value={this.state.id_uf} onChange={this.handleChange.bind(this, 'id_uf')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.OrgaoDeExpedicao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.OrgaoExpeditorDaID} className="form-control" disabled name="id_exp" value={this.state.id_exp} onChange={this.handleChange.bind(this, 'id_exp')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.IDExpedicao}:</label>
          <InputMask value={this.state.id_date} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpedicaoDaID} maskChar={null} name="id_date" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'id_date')}/>
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoUF}:</label>
          <input type="text" className="form-control" disabled placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoUF} name="ctps_uf" value={this.state.ctps_uf} onChange={this.handleChange.bind(this, 'ctps_uf')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoProfissional}:</label>
          <input type="text" className="form-control" disabled placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoProfissional} name="ctps" value={this.state.ctps} onChange={this.handleChange.bind(this, 'ctps')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoExpedicao}:</label>
          <InputMask value={this.state.ctps_expedition} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoExpedicao} maskChar={null} name="ctps_expedition" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'ctps_expedition')}/>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.EscolaFormacao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EscolaFormacao} className="form-control" disabled name="escola_formacao" value={this.state.escola_formacao} onChange={this.handleChange.bind(this, 'escola_formacao')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Escolaridade}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Escolaridade} className="form-control" disabled name="scholarly" value={this.state.scholarly} onChange={this.handleChange.bind(this, 'scholarly')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ConfidenceUS}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoCartaoConfidenceAmericano}className="form-control" disabled name="confidence_us" value={this.state.confidence_us} onChange={this.handleChange.bind(this, 'confidence_us')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ExpiracaoConfidenceUS}:</label>
          <InputMask value={this.state.expire_us} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValidadeDoCartaoConfidenceAmericano} maskChar={null} name="expire_us" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'expire_us')}/>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ConfidenceEU}:</label>
          <input type="text" className="form-control" disabled placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoCartaoConfidenceEuropeu} name="confidence_eu" value={this.state.confidence_eu} onChange={this.handleChange.bind(this, 'confidence_eu')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ExpiracaoConfidenceEU}:</label>
          <InputMask value={this.state.expire_eu} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValidadeDoCartaoConfidenceEuropeu} maskChar={null} name="expire_eu" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'expire_eu')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Passaporte}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoPassaporte} className="form-control" disabled name="passport" value={this.state.passport} onChange={this.handleChange.bind(this, 'passport')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PassaporteExpiracao}:</label>
          <InputMask value={this.state.passport_expiration} placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpiracaoDoPassaporte} maskChar={null} name="passport_expiration" mask="99/99/9999" className="form-control" disabled onChange={this.handleChange.bind(this, 'passport_expiration')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.TituloDeEleitor}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TituloDeEleitor} className="form-control" disabled name="voting_title" value={this.state.voting_title} onChange={this.handleChange.bind(this, 'voting_title')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ZonaDeEleitor}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ZonaDeEleitor} className="form-control" disabled name="voting_title_zone" value={this.state.voting_title_zone} onChange={this.handleChange.bind(this, 'voting_title_zone')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.SessaoDeEleitor}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SessaoDeEleitor} className="form-control" disabled name="voting_title_session" value={this.state.voting_title_session} onChange={this.handleChange.bind(this, 'voting_title_session')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNHCategoria}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CNHCategoria} className="form-control" disabled name="cnh_cat" value={this.state.cnh_cat} onChange={this.handleChange.bind(this, 'cnh_cat')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNH}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDaCarteiraDeMotorista} className="form-control" disabled name="cnh" value={this.state.cnh} onChange={this.handleChange.bind(this, 'cnh')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNHExpiracao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpiracaoDaCarteiraDeMotorista} className="form-control" disabled name="cnh_expiration" value={this.state.cnh_expiration} onChange={this.handleChange.bind(this, 'cnh_expiration')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Reservista}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Reservista} className="form-control" disabled name="reservista" value={this.state.reservista} onChange={this.handleChange.bind(this, 'reservista')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ReservistaCategoria}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ReservistaCategoria} className="form-control" disabled name="reservista_cat" value={this.state.reservista_cat} onChange={this.handleChange.bind(this, 'reservista_cat')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitar}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitar} className="form-control" disabled name="certificado_militar" value={this.state.certificado_militar} onChange={this.handleChange.bind(this, 'certificado_militar')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitarMinisterio}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitarMinisterio} className="form-control" disabled name="certificado_militar_ministerio" value={this.state.certificado_militar_ministerio} onChange={this.handleChange.bind(this, 'certificado_militar_ministerio')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitarObservacoes}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitarObservacoes} className="form-control" disabled name="certificado_militar_obs" value={this.state.certificado_militar_obs} onChange={this.handleChange.bind(this, 'certificado_militar_obs')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.VistoAmericano}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.VistoAmericano} className="form-control" disabled name="visto_usa" value={this.state.visto_usa} onChange={this.handleChange.bind(this, 'visto_usa')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREA}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREA} className="form-control" disabled name="crea" value={this.state.crea} onChange={this.handleChange.bind(this, 'crea')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREATitulo}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREATitulo} className="form-control" disabled name="crea_titulo" value={this.state.crea_titulo} onChange={this.handleChange.bind(this, 'crea_titulo')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREAExpedicao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREAExpedicao} className="form-control" disabled name="crea_expedicao" value={this.state.crea_expedicao} onChange={this.handleChange.bind(this, 'crea_expedicao')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREAValidade}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREAValidade} className="form-control" disabled name="crea_validade" value={this.state.crea_validade} onChange={this.handleChange.bind(this, 'crea_validade')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ASO}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ASO} className="form-control" disabled name="aso" value={this.state.aso} onChange={this.handleChange.bind(this, 'aso')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Contratacao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Contratacao} className="form-control" disabled name="hired" value={this.state.hired} onChange={this.handleChange.bind(this, 'hired')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Demissao}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Demissao} className="form-control" disabled name="fired" value={this.state.fired} onChange={this.handleChange.bind(this, 'fired')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.NomeDaMae}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDaMaeDoColaborador} className="form-control" disabled name="mom" value={this.state.mom} onChange={this.handleChange.bind(this, 'mom')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.NomeDoPai}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDoPaiDoColaborador} className="form-control" disabled name="dad" value={this.state.dad} onChange={this.handleChange.bind(this, 'dad')} />
        </div>
      </div>
      <h4>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.tituloInformacoesProfissionais}</h4>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Licenca}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Licenca} className="form-control" disabled name="license" value={this.state.license} onChange={this.handleChange.bind(this, 'license')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CANAC}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CANAC} className="form-control" disabled name="canac" value={this.state.canac} onChange={this.handleChange.bind(this, 'canac')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Matricula}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.InscricaoDoColaborador} className="form-control" disabled name="inscription" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ValorHora}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValorHora} className="form-control" disabled name="hour_value" value={this.state.hour_value} onChange={this.handleChange.bind(this, 'hour_value')} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ContratoSISPAT}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ContratoSISPAT} className="form-control" disabled name="sispat" value={this.state.sispat} onChange={this.handleChange.bind(this, 'sispat')} />
        </div>
        <div className="col-md-6 form-group">
          <label>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CodigoSapiens}:</label>
          <input type="text" placeholder={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CodigoSapiens} className="form-control" disabled name="sapiens_code" value={this.state.sapiens_code} onChange={this.handleChange.bind(this, 'sapiens_code')} />
        </div>
      </div>
      <hr/>
      {/* <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar informações</button> */}
    </form>
  </div>
</div>
    );
  }
}

export default StaffEditTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffEditTab.js